import { useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import { makeUrlCard } from './connectionData'
import { useAuth } from './useAuth'

import { UserProfileRole } from '@/modules/users/types/UserProfile'
import { customFetch } from '@/utils/customFetch'
import CardDto from '@/interfaces/CardDto'
import { AppPath } from '@/enums/AppPath'

const useCardsFetcher = () => {
  const [error, setError] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const [searchParams] = useSearchParams()
  const { userData, hasRole } = useAuth()

  const fetchData = async (docuType: AppPath, estado: number) => {
    setLoading(true)

    console.log('external', searchParams.get('external'))

    try {
      // EL estado es el boton presionado (vigentes, expiradas, etc)
      const apiUrl = makeUrlCard(
        docuType,
        estado,
        userData?.organization?._id ?? '',
        searchParams.get('external') ?? ''
      )
      const data = await customFetch<CardDto[]>(apiUrl)
      const dataNew = checkPrivileges(docuType) ? data.filter((e) => e.user.email === userData?.profile?.email) : data

      setError(null)

      return dataNew
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setError(err)
      } else {
        setError(new Error('An unknown error occurred'))
      }

      return []
    } finally {
      setLoading(false)
    }
  }

  const checkPrivileges = (docuType: AppPath) => {
    if (
      docuType === AppPath.Estimates &&
      !hasRole(UserProfileRole.AllEstimates) &&
      hasRole(UserProfileRole.OwnEstimates)
    ) {
      return true
    }

    if (
      docuType === AppPath.Reservations &&
      !hasRole(UserProfileRole.AllReservations) &&
      hasRole(UserProfileRole.OwnReservations)
    ) {
      return true
    }

    return false
  }

  // Exponemos estas variables al exterior
  return { error, loading, fetchData }
}

export default useCardsFetcher
